import { useState } from 'react';
import { useAtom } from 'jotai';
import { weightLossProgressAtom } from './model/weightLossProgressAtom';
import { weightLogsAtom } from './model/weightLogsAtom';
import { Utils } from '@/shared/Utils';
import { fetchNnSundvaegtProgramAtom } from './model/fetchNnSundvaegtProgramAtom';

export const useNnSundVaegtProgram = () => {
    const [{ data: program }] = useAtom(fetchNnSundvaegtProgramAtom);
    const [weightLossProgress] = useAtom(weightLossProgressAtom);
    const [weightLogCards] = useAtom(weightLogsAtom);

    const totalVideoConsultations = program?.TotalConsultations;
    const consultationsUsed = program?.ConsultationsUsed;
    const freeVideoConsultationsLeft =
        totalVideoConsultations - consultationsUsed;
    const formattedExpiryDate = Utils.formatLongDate(program?.ExpiryDate);

    const firstLog = weightLogCards?.cards.find(
        (x) => x.formattedLastLoss == null,
    );

    const [showWeightGoalModal, setShowWeightGoalModal] = useState(false);
    const [showAddWeightLogModal, setShowAddWeightLogModal] = useState(false);

    const openWeightGoalModal = () => setShowWeightGoalModal(true);
    const closeWeightGoalModal = () => setShowWeightGoalModal(false);

    const openAddWeightLogModal = () => setShowAddWeightLogModal(true);
    const closeAddWeightLogModal = () => setShowAddWeightLogModal(false);

    return {
        weightLossProgress,
        weightLogCards,
        firstLog,
        showWeightGoalModal,
        openWeightGoalModal,
        closeWeightGoalModal,
        showAddWeightLogModal,
        openAddWeightLogModal,
        closeAddWeightLogModal,
        formattedExpiryDate,
        freeVideoConsultationsLeft,
        totalVideoConsultations,
        consultationsUsed,
    };
};
